import { addMutator } from '@poa/state';

import {
  fetch,
  refreshStaff,
  fetchSuccess,
  fetchFailed,
  setDates,
  saveColumnPreset,
  toggleFavorite,

  // presets
  changeColumnPreset,
  changeColumnVisibility,
  changeRounding,
  changeSearch,
  resetColumnSettings,
  toggleAllColumns,
  changePresetOrder,
  deletePreset,
  changeFiltering,
  resetFilteringOptions
} from './staff.actions';
import { clone } from '../shared/clone';

// fetch
addMutator(fetch, (payload, { store }) => {
  store.staff.meta.isLoading = true;
  store.staff.meta.hasError = false;
});

// refreshStaff
addMutator(refreshStaff, (payload, { store }) => {
  store.staff.meta.isLoading = true;
  store.staff.meta.hasError = false;
});

addMutator(fetchSuccess, ({ data, meta }, { store }) => {
  store.staff.meta.isLoading = false;
  store.staff.meta.hasError = false;

  store.staff.data.replace(data);
  store.staff.meta.loaded = true;
});

addMutator(fetchFailed, (payload, { store }) => {
  store.staff.meta.isLoading = false;
  store.staff.meta.hasError = true;
});

// ui
addMutator(toggleFavorite, ({ id }, { store }) => {
  const { favorites } = store.staff.ui;

  const idx = favorites.indexOf(id);

  if (idx === -1) {
    // add new
    favorites.push(id);
  } else {
    // remove existing
    favorites.splice(idx, 1);
  }
});

addMutator(changeFiltering, ({ filtering }, { store }) => {
  console.log('changeFiltering', filtering);
  store.staff.filters.filtering.selected = filtering;
});

addMutator(resetFilteringOptions, ({ filtering }, { store }) => {
  const procesedOptions = filtering.map(f => ({ label: f.title, value: f.id }));
  procesedOptions.unshift({ label: '-', value: 'all' });
  store.staff.filters.filtering.options = procesedOptions;
  store.staff.filters.filtering.selected = procesedOptions[0];
});

addMutator(setDates, ({ startDate, endDate }, { store }) => {
  store.staff.filters.startDate = startDate;
  store.staff.filters.endDate = endDate;
});

// presets
addMutator(changeColumnPreset, ({ presetId }, { store }) => {
  store.staff.filters.columnSettings.currentPresetId = presetId;

  store.staff.filters.columnSettings.lastSelectedPresetColumns = clone(
    store.staff.selectors.selectedPreset.columnsConfiguration
  );
});

addMutator(changeColumnVisibility, ({ column }, { store }) => {
  column.isSelected = !column.isSelected;
});

addMutator(toggleAllColumns, (_, { store }) => {
  const newStatus = !store.staff.selectors.isAllColumnsSelected;

  store.staff.selectors.selectedPreset.columnsConfiguration.forEach(
    c => (c.isSelected = newStatus)
  );
});

addMutator(saveColumnPreset, ({ preset }, { store }) => {
  const { selectedPreset } = store.staff.selectors;
  const { columnSettings } = store.staff.filters;
  const savedColumnsConfiguration = clone(selectedPreset.columnsConfiguration);

  const newPreset = {
    id: Math.random(),
    label: preset.label,
    columnsConfiguration: savedColumnsConfiguration
  };

  selectedPreset.columnsConfiguration = clone(columnSettings.lastSelectedPresetColumns);

  columnSettings.currentPresetId = newPreset.id;
  columnSettings.availablePresets.push(newPreset);

  columnSettings.lastSelectedPresetColumns = savedColumnsConfiguration;
});

addMutator(deletePreset, ({ id }, { store }) => {
  const { selectedPreset } = store.staff.selectors;
  const { columnSettings } = store.staff.filters;

  // you try to delete default preset?
  if (id === 0) {
    console.warn('You try to delete default preset. This is illegal operation.');
    return;
  }

  // find preset index that we want to delete
  const presetIndex = columnSettings.availablePresets.findIndex(preset => preset.id === id);

  // delete preset by index
  columnSettings.availablePresets.splice(presetIndex, 1);

  // apply previous preset
  columnSettings.currentPresetId = columnSettings.availablePresets[presetIndex - 1].id;
  columnSettings.lastSelectedPresetColumns = clone(selectedPreset.columnsConfiguration);
});

addMutator(resetColumnSettings, ({ presetId, availablePresets }, { store }) => {
  const { selectedPreset } = store.staff.selectors;
  const { columnSettings } = store.staff.filters;

  columnSettings.currentPresetId = presetId;
  columnSettings.availablePresets = availablePresets;

  columnSettings.lastSelectedPresetColumns = clone(selectedPreset.columnsConfiguration);
});

addMutator(changeRounding, ({ isDecimal }, { store }) => {
  store.staff.filters.isDecimal = isDecimal;
});

addMutator(changeSearch, ({ searchClause }, { store }) => {
  store.staff.filters.search = searchClause;
});

addMutator(changePresetOrder, ({ columns }, { store }) => {
  const { selectedPreset } = store.staff.selectors;

  selectedPreset.columnsConfiguration = columns.map(columnName =>
    selectedPreset.columnsConfiguration.find(colConfig => colConfig.name === columnName)
  );
});
